import Observer from '../../common/scripts/observer';

const observer = new Observer();

class Accordion {
    constructor() {
        this.activeClass = 'accordion_is_open';
        this.state = 'close';
    }

    /**
     * Иницализирует модуль
     * @param {object} wrapper - Обертка аккордиона
     */
    init(wrapper) {
        this.wrapper = wrapper;
        this.header = wrapper.querySelector('.accordion__header');
        this.contentWrapper = wrapper.querySelector('.accordion__content-wrapper');
        this.content = wrapper.querySelector('.accordion__content');
        this.height = this.content.offsetHeight;
        this.child = Array.from(this.wrapper.querySelectorAll('.j-accordion-child'));
        this.control = this.wrapper.dataset.control;

        this._bindEvents();

        // ждем пока построится дом, для решения бага на ff
        const renderDomDelay = 300;

        setTimeout(() => {
            this.height = this.content.offsetHeight;

            if (this.child.length) {
                this._initChild();
            }

            this._checkActiveState();
        }, renderDomDelay);
    }

    /**
     * Если изначально установлен активный класс, то метод откроет аккордион.
     * @private
     */
    _checkActiveState() {
        const isActive = this.wrapper.classList.contains(this.activeClass);

        if (isActive) {
            this.contentWrapper.style.height = `${this.height}px`;
            this.state = 'open';
        }
    }

    /**
     * Метод инциализирует аккордиончики если они есть.
     */
    _initChild() {
        this.child.forEach((item) => {
            const wrapper = item;
            const header = item.querySelector('.accordion__header');
            const contentWrapper = item.querySelector('.accordion__content-wrapper');
            const content = item.querySelector('.accordion__content');

            header.addEventListener('click', () => {
                const heightChild = content.offsetHeight;

                if (wrapper.classList.contains(this.activeClass)) {
                    wrapper.classList.remove(this.activeClass);
                    contentWrapper.style.height = 0;
                    this.height = this.height - heightChild;
                } else {
                    wrapper.classList.add(this.activeClass);
                    contentWrapper.style.height = `${heightChild}px`;
                    this.height = this.height + heightChild;
                }

                this.contentWrapper.style.height = `${this.height}px`;
            });
        });
    }

    /**
     * Навешивает обработчики событий
     */
    _bindEvents() {
        this.header.addEventListener('click', () => {
            this.height = this.content.offsetHeight;

            if (this.wrapper.classList.contains(this.activeClass)) {
                this.close();
            } else {
                this.open();
            }
        });

        window.addEventListener('resize', () => {
            this.update();
        });
    }

    /**
     * Закрывает аккордион
     */
    close() {
        this.wrapper.classList.remove(this.activeClass);
        this.contentWrapper.style.height = 0;
        this.state = 'close';

        observer.publish('changeAccordion', this);
    }

    /**
     * Открывает аккордион
     */
    open() {
        this.wrapper.classList.add(this.activeClass);
        this.contentWrapper.style.height = `${this.height}px`;
        this.state = 'open';

        observer.publish('changeAccordion', this);
    }

    /**
     * Обновляет высоту открытого аккардеона
     */
    update() {
        const isActive = this.wrapper.classList.contains(this.activeClass);

        this.height = this.content.offsetHeight;

        if (isActive) {
            this.contentWrapper.style.height = `${this.height}px`;
        }
    }
}

export default Accordion;
